//rework
import firebase from "firebase/app";

class FirebaseService {
  async delete(path, fileName) {
    const ref = firebase.storage().ref(path);
    const childRef = ref.child(fileName);
    return childRef.delete();
  }

  async deleteFile(path, fileName) { return this.delete(path, fileName); }

  async uploadOrThrow(path, file) {
    const uploaded = await firebase.storage().ref().child(path).put(file);
    return uploaded.ref.getDownloadURL();
  }

  async upload(_path, _file) {
    try {
      const file = await firebase.storage().ref().child(_path).put(_file);
      const fileUrl = await file.ref.getDownloadURL();

      return fileUrl.toString();
    } catch (error) {
      return "error";
    }
  }
}

export default new FirebaseService();
